import {
  CHECK_UNREAD_NOTIFICATIONS,
  NEW_NOTIFICATION,
  FETCH_NOTIFICATIONS,
} from './actionTypes';

const initialState = {
  unreadNotifications: false,
  all: [],
};

export default function notifications(state = initialState, action) {
  switch(action.type) {
    case CHECK_UNREAD_NOTIFICATIONS:
      return {...state, unreadNotifications: action.payload}
    case NEW_NOTIFICATION:
      return {...state, unreadNotifications: true}
    case FETCH_NOTIFICATIONS:
      return {...state, all: action.payload}
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/notifications/reducers.js